var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inProgress)?_c('div',[_c('b-progress',{attrs:{"id":"progress"}},[_c('b-progress-bar',{attrs:{"value":_vm.progressPercentage,"label":_vm.label}})],1),_c('div',{staticClass:"modal-backdrop custom"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }